<template>
    <aside class='menu'>
        <p class='menu-label'>管理</p>
        <ul class='menu-list'>
            <li @click='toParamLink("/lab")'><a>注文一覧</a></li>
            <li @click='toParamLink("/lab/photographer")'><a>カメラマン管理</a></li>
        </ul>
        <p class='menu-label'>設定</p>
        <ul class='menu-list'>
            <li  @click='toParamLink("/lab/setting")'><a>ユーザー設定</a></li>
        </ul>
        <p class='menu-label'>その他</p>
        <ul class='menu-list'>
            <li @click='logout'><a class='has-text-danger'>ログアウト</a></li>
        </ul>
    </aside>
</template>

<script>

export default {
    name: 'Sidebar',
    components: {
    },
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
        toParamLink (link) {
            if (this.getParamId()) link += `?id=${this.getParamId()}`

            this.$router.push(link)
        },
        getParamId () {
            return this.$route.query.id
        },
        logout () {
            this.$root.$emit('logout')
        }
    }
}
</script>

<style scoped>
.menu {
    min-height: calc(100vh - 80px);
    min-width: 230px;
    padding-top: 20px;
    padding-left: 18px;
    padding-bottom: 10px;
    background-color: #fafafa;
}

.menu-label {
    font-size: 15px;
}

a {
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/lab/Sidebar.vue